import type { Styles } from '@adornis/ass/style.js';
import { DigitaleHeldenFont } from '@adornis/digitale-helden-shared/client/theme/fonts';
import { fontReset } from '@adornis/fonts/font-resets.js';
import { XH4 } from '@adornis/fonts/fonts';
import { customElement } from 'lit/decorators.js';

@customElement('d-h4')
export class DH4 extends XH4 {
  override styles() {
    return [fontReset(DigitaleHeldenFont.BLACK, 1, undefined, 1.25, 16), { color: '#BBBBB4' }] as Styles[];
  }
}
